import { useTranslate, useApiUrl } from "@pankod/refine-core";

import {
  Edit,
  Drawer,
  DrawerProps,
  Form,
  FormProps,
  Input,
  InputNumber,
  Radio,
  Select,
  Space,
  ButtonProps,
  Typography,
  Upload,
  Grid,
  getValueFromEvent,
  useSelect,
  //DatePicker,
  SaveButton,
} from "@pankod/refine-antd";

import dayjs from "dayjs";
import { DatePicker } from "antd";

import { TOKEN_KEY } from "../../constants";

import {
  normalizeFile,
  mediaUploadMapper,
  getValueProps,
} from "utility/normalize";
import { useApiUpload } from "hooks/upload";
import { statusTypes } from "constants/common";

const { Text } = Typography;

type EditContractProps = {
  drawerProps: DrawerProps;
  formProps: FormProps;
  saveButtonProps: ButtonProps;
};

export const EditContract: React.FC<EditContractProps> = ({
  drawerProps,
  formProps,
  saveButtonProps,
}) => {
  const t = useTranslate();
  const apiUrl = useApiUrl();
  const breakpoint = Grid.useBreakpoint();
  const { ...uploadProps } = useApiUpload({
    maxCount: 2,
  });

  function onChange(value: any) {
    console.log(value);
  }

  return (
    <Drawer
      {...drawerProps}
      width={breakpoint.sm ? "500px" : "100%"}
      bodyStyle={{ padding: 0 }}
    >
      <Edit resource="contracts" pageHeaderProps={{ extra: null }}
        actionButtons={
          <>
            <SaveButton
              {...saveButtonProps}
              style={{ marginRight: 10 }}
            />
          </>
        }
      >
        <Form {...formProps} layout="vertical"
          onFinish={(values) => {
            values = { ...values, images: getValueProps(values?.images, "") };
            return formProps.onFinish?.(mediaUploadMapper(values));
          }}
        >

          <Form.Item

            label={t("contracts.fields.description")}
            name="description"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item

            label={t("contracts.fields.nameOfContractor")}
            name="nameOfContractor"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label={t("contracts.fields.contractorPosition")}
            name="contractorPosition"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item

            label={t("contracts.fields.date")}
            name="date"
            rules={[
              {
                required: true,
              },
            ]}
            getValueProps={(value) => ({
              value: value ? dayjs(value) : "",
            })}
          >
            <DatePicker placeholder={t("contracts.fields.date")} />
          </Form.Item>
          <Form.Item label={t("contracts.fields.file")}>
            <Form.Item
              label={t("contracts.fields.file")}
              name="images"
              normalize={normalizeFile}
              getValueProps={(data) => getValueProps(data, "")}
              valuePropName="fileList"
              noStyle
            >
              <Upload.Dragger
                name="file"
                action={`${apiUrl}/media_objects`}
                headers={{
                  Authorization: `Bearer ${localStorage.getItem(TOKEN_KEY)}`,
                }}
                listType="picture"
                multiple
                {...uploadProps}
              >
                <p className="ant-upload-text">{t("upload.areaTitle")}</p>
              </Upload.Dragger>
            </Form.Item>
          </Form.Item>
          <Form.Item
            label={t("contracts.fields.status")} name="status"  >

            <Select options={Object.values(statusTypes).map((p) => ({
              label: t(`${p.label}`),
              value: p.value,
            }))}
              onChange={onChange}
              placeholder={t("buttons.pleaseSelect")}
            />
          </Form.Item>
        </Form>
      </Edit>
    </Drawer>
  );
};
